import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const CREDIT_CARD_APPLICATION_REPORT_URL = `${API_URL}/credit-card-applications`

export const service = {
  getCreditCardApplicationReport: (params: ParamsModel) => {
    return axios.get(CREDIT_CARD_APPLICATION_REPORT_URL, {params})
  },
  getCreditCardApplicationReportDetail: (id: string) => {
    return axios.get(`${CREDIT_CARD_APPLICATION_REPORT_URL}/${id}`)
  },
  updateCreditCardApplicationStatus: (id: string, status: string) => {
    return axios.patch(`${CREDIT_CARD_APPLICATION_REPORT_URL}/${id}/status`, {status})
  },
}
